import { TermItem, TermList } from 'app/shared/components/TermList'
import TermListCheckCard from 'app/shared/components/TermListCheckCard'
import {
    TermListMarketing,
    TermsMarketing,
} from 'app/shared/components/TermListMarketing'
import TermListMarketingCard from 'app/shared/components/TermListMarketingCard'
import { Button } from 'primereact/button'
import { ObjectUtils } from 'primereact/utils'
import * as React from 'react'

const PgTerms: React.FC = () => {
    //일반 약관
    const [items, setItems] = React.useState<TermItem[]>([
        {
            name: '전자금융거래기본 약관',
            required: true,
            termId: 'TERM-026',
            checked: false,
        },
        {
            name: '전자금융서비스이용 약관',
            required: true,
            termId: 'TERM-027',
            checked: true,
        },
        {
            name: '개인정보수집·이용 위탁동의',
            required: true,
            termId: 'TERM-028',
            checked: true,
        },
        {
            name: '고유식별정보처리',
            required: true,
            termId: 'TERM-003',
            checked: true,
        },
        {
            name: '통신사 이용약관',
            required: true,
            termId: 'TERM-029',
            checked: true,
        },
        {
            name: '본인확인서비스 이용약관',
            required: true,
            termId: 'TERM-004',
            checked: true,
        },
    ])
    //Item을 State로 사용하는 경우 테스트
    const updateItems = () => {
        const newItems = items.concat()
        newItems[0].checked = true
        setItems(newItems)
    }
    //1개짜리 약관
    const items1: TermItem[] = [
        {
            name: '전자금융거래기본 약관',
            // required: true,
            // termId: '111111'
        },
    ]
    //마케팅 - API 명세서에 따름. TODO: 마케팅 수신 동의를 안했는데, 매체 선택이 가능한지는 추후 확인
    const termsMarketing: TermsMarketing = {
        mrknCosnYn: 'N',
        mrknInfoRcctYn: 'Y',
        smsMrknCosnYn: 'N',
        telMrknCosnYn: 'Y',
        emlMrknCosnYn: 'N',
        psmlMrknCosnYn: 'N',
    }
    // 체크카드 가입 마케팅 동의
    const termsMarketCard = {
        //상품이용권유동의여부
        pdfUtlSlcsYn: 'N',
        //상품부수서비스안내동의여부
        pdfNmcpSrgnCosnYn: 'N',
        //전자광고정보수신동의여부
        elcrAdvsIfrcCosnYn: 'N',
        //  신용카드전화권유동의여부
        crdTelSlcsYn: 'N',
        //  신용카드SMS권유동의여부
        crdSmsSlcsYn: 'N',
        //  신용카드서면권유동의여부
        crdInwrSlcsYn: 'N',
        //  신용카드이메일권유동의여부
        crdEmlSlcsYn: 'N',
    }
    return (
        <div style={{ padding: '1em' }}>
            <TermList
                title="null/undefined test"
                required={false}
                items={null}
            />
            <br />

            <TermList
                title={
                    <>
                        휴대폰 인증 약관에
                        <br />
                        모두 동의합니다
                    </>
                }
                required={false}
                items={items}
                onChange={(items, state, isAllChecked) => {}}
            />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="아이템 업데이트 테스트"
                onClick={updateItems}
            />
            <br />
            <TermList
                items={items1}
                onChange={(items, state, isAllChecked) => {}}
            />
            <br />
            <TermListMarketing
                terms={termsMarketing}
                onChange={(terms, isAllChecked) => {}}
            />
            <br />
            <span>체크카드 약관</span>
            <TermListCheckCard
                // terms={}
                onChange={(isAllChecked) => {}}
            />
            <br />
            <span>체크카드 마케팅약관</span>
            <TermListMarketingCard
                // 서버에서 받은 값을 설정하려면 아래 주석을 풀어주소서
                // terms={}
                onChange={(terms, isAllChecked) => {}}
            />
        </div>
    )
}

export default PgTerms
